export default __webpack_public_path__ + "img/blvUvCKB.5643fb96.svg";